/** Membership test that narrows an unknown server string to a value the client knows (HS-961). */
export function isOneOf<T extends string>(values: readonly T[], value: string): value is T {
  return (values as readonly string[]).includes(value);
}
